import { StaticBaseDao } from '@/dao';
import { SeedingListSelectLine, SearchRequest, TypeAheadResponse } from '@/objects/generated';

export class SeedingListDao extends StaticBaseDao {
    public static async SeedingListAsSelectLine(seedingListId: number): Promise<SeedingListSelectLine | null> {
        return this.BaseFetch(
            SeedingListSelectLine,
            `SeedingList/SeedingListAsSelectLine` + '?' + (seedingListId == undefined ? '' : `seedingListId=${seedingListId}`),
            'GET',
        );
    }
    public static async TypeaheadSearch(request: SearchRequest): Promise<TypeAheadResponse | null> {
        return this.BaseFetch(TypeAheadResponse, `SeedingList/TypeaheadSearch`, 'POST', request);
    }
}
